export enum MessageId {
  INITIAL_MESSAGE = 'initial-message',
  PENDING_RESPONSE = 'pending-response',
  ASSISTANT_THINKING = 'assistant-thinking'
}
